import Home from "@/views/Home.vue"
import NotFound from "@/views/NotFound.vue"
import Forbidden from "@/views/Forbidden.vue"
import Contact from "@/views/Contact.vue"
import Blog from "@/views/Blog.vue"
import BlogDetails from "@/views/BlogDetails.vue"
import Pages from "@/views/Pages.vue"

export const appRoutes = [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            title: 'routes.titles.home',
            description: 'routes.descriptions.home',
            requiresAuth: false
        }
    },
    {
        path: '/403',
        name: 'forbidden',
        component: Forbidden,
        meta: {
            title: 'routes.titles.forbidden',
            description: 'routes.descriptions.forbidden',
            requiresAuth: false
        }
    },
    {
        path: '/blog',
        name: 'blog',
        component: Blog,
        meta: {
            title: 'routes.titles.blog',
            description: 'routes.descriptions.blog',
            requiresAuth: false
        }
    },
    {
        path: '/blog/:slug',
        name: 'blog-details',
        component: BlogDetails,
        meta: {
            title: 'routes.titles.blog_details',
            description: 'routes.descriptions.blog_details',
            requiresAuth: false
        }
    },
    {
        path: '/contact',
        name: 'contact',
        component: Contact,
        meta: {
            title: 'routes.titles.contact',
            description: 'routes.descriptions.contact',
            requiresAuth: false
        }
    },
    {
        path: '/pages/:slug',
        name: 'pages',
        component: Pages,
        meta: {
            title: 'routes.titles.pages',
            description: 'routes.descriptions.pages',
            requiresAuth: false
        }
    },
    // Catch-all route - MUST be last to avoid intercepting other routes
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: NotFound,
        meta: {
            title: 'routes.titles.not_found',
            description: 'routes.descriptions.not_found',
            requiresAuth: false
        }
    }
]
